export default __webpack_public_path__ + "static/media/course.6ceb96e3.jpg";